import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { ReactNode } from 'react'

type RowContentProps = {
  label: string
  content: ReactNode
  incompleteMessage?: string
  className?: string
}

const RowContent = ({ content, incompleteMessage, label, className }: RowContentProps) => {
  const stringValue = content || incompleteMessage || 'Incomplete'

  return (
    <div className={classNames('flex flex-col', className)}>
      <p className={classNames('typography-caption mb-2', !content ? 'text-fuchsia-800' : 'text-neutral-500')}>
        {label}
      </p>

      {typeof content === 'string' ? (
        <p className={classNames('typography-body-l', !content ? 'text-fuchsia-800' : 'text-neutral-600')}>
          {stringValue}
        </p>
      ) : (
        content
      )}
    </div>
  )
}

export default RowContent
